import { render, staticRenderFns } from "./verify-email.vue?vue&type=template&id=747d0806&scoped=true"
import script from "./verify-email.vue?vue&type=script&lang=js"
export * from "./verify-email.vue?vue&type=script&lang=js"
import style0 from "./verify-email.vue?vue&type=style&index=0&id=747d0806&prod&scoped=true&lang=css"
import style1 from "./verify-email.vue?vue&type=style&index=1&id=747d0806&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747d0806",
  null
  
)

export default component.exports